import { render } from "./IconResultFold.vue?vue&type=template&id=71f0e72d"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconResultFold.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71f0e72d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71f0e72d', __exports__)) {
    api.reload('71f0e72d', __exports__)
  }
  
  module.hot.accept("./IconResultFold.vue?vue&type=template&id=71f0e72d", () => {
    api.rerender('71f0e72d', render)
  })

}


export default __exports__